import React from 'react';
import { getTableColumns } from 'helpers';
import { FasHistory } from 'assets/icons';
import atoms from 'ctsutheme/components/atoms';
import { CanUserAuditCohorts } from 'appconstants/Permission';
import { BoolToString } from "components";

const { IconButton, Typography } = atoms;

const RemainingColumns =  [['description', 'string', 'Description', 'left', true],
['status', 'string', 'Status', 'left', true],
['statusReason', 'string', 'Reason', 'left', true],
['statusDate', 'string', 'Status Date', 'left', true],
['targetAccrual', 'string', 'Accrual Target', 'left', true],
['currentAccrual', 'string', 'Current Accrual', 'left', true]]
const CohortsColumns = [
{
  name: 'cohortName',
    type: 'string',
    label: 'Cohort',
    align: 'left',
    sort: true,
    renderCell : (data, rowInfo) =>   <>
     {CanUserAuditCohorts() && (<Typography component="span" inline link icon>
             <IconButton
                 aria-label="Move row down"
                 color="inherit"
                 data-id="stratum"
                 onClick={(e) => rowInfo[0](e, data)}
             >
             <FasHistory />
             </IconButton>
         </Typography>)}
      <span style={{ marginRight: '1rem' }}>
       {data.cohortName}
     </span>
     </>
    
},
  { name: 'strata',
    type: 'string',
    label: 'Strata?',
    align: 'left',
    sort: true,
    renderCell : (data, rowInfo) => <BoolToString boolValue={data.stratums.length > 0}/>
    },
  ...getTableColumns(RemainingColumns)
  ];
  
  
  export default CohortsColumns;
  